import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const purchases = [{
  name: 'Sarah H.',
  location: 'Manchester, United Kingdom'
}, {
  name: 'James T.',
  location: 'Leeds, United Kingdom'
}, {
  name: 'Emily C.',
  location: 'Bristol, United Kingdom'
}, {
  name: 'Ryan M.',
  location: 'Toronto, Canada'
}, {
  name: 'Chloe B.',
  location: 'Vancouver, Canada'
}, {
  name: 'Daniel K.',
  location: 'Calgary, Canada'
}, {
  name: 'Ashley R.',
  location: 'Austin, United States'
}, {
  name: 'Michael P.',
  location: 'Denver, United States'
}, {
  name: 'Jessica L.',
  location: 'Charlotte, United States'
}, {
  name: 'Liam W.',
  location: 'Melbourne, Australia'
}, {
  name: 'Olivia S.',
  location: 'Brisbane, Australia'
}, {
  name: 'Jack D.',
  location: 'Perth, Australia'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    const timeout = setTimeout(showPopup, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-3 left-3 z-50 animate-slide-in" role="status" aria-live="polite" data-id="element-176" data-mp="2qcj58zn3fynu">
      <div className="bg-white border-2 border-brand-green rounded-xl shadow-2xl p-2.5 pr-7 max-w-[250px] relative overflow-hidden ring-2 ring-brand-orange/40" data-id="element-177" data-mp="2lf0vx855zhfb">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-orange" data-id="element-178" data-mp="2ceks1xkie89x" />
        <button type="button" onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-brand-slate/60 hover:text-brand-ink transition-colors duration-150 ease-out" aria-label="Dismiss notification" data-id="element-179" data-mp="14zzjrpdkgz8r">
          <XIcon className="w-3.5 h-3.5" data-id="element-180" data-mp="12dqgg71wu3at" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-181" data-mp="17duy40ek142m">
          <div className="w-8 h-8 rounded-full bg-brand-green/15 border border-brand-green/40 flex items-center justify-center shrink-0" data-id="element-182" data-mp="17cjtxzh75uaz">
            <ShoppingBagIcon className="w-4 h-4 text-brand-green" aria-hidden="true" data-id="element-183" data-mp="xfxa9e0lx9aj" />
          </div>
          <div className="leading-tight" data-id="element-184" data-mp="jo0jpeel77g9">
            <p className="font-heading font-bold text-brand-ink text-[13px]" data-id="element-185" data-mp="ogk0slchgkpt">
              {current.name}
            </p>
            <p className="text-[10px] text-brand-slate font-medium" data-id="element-186" data-mp="9s70jc6d4fpi">
              {current.location}
            </p>
            <p className="text-[11px] text-brand-green font-bold mt-0.5" data-id="element-187" data-mp="eqqmvdovbtie">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </div>;
}